module.exports = __webpack_public_path__ + "img/home@3x.1b097750.png";